var AnimationHandler = (() => {
    var _this, CONFIG, TIMER;

    CONFIG = {
        ELEMENT: {
            $html: $('html'),
            $body: $('body'),
            $htmlBody: $('html,body')
        },
        PULSE: {
            in: {
                duration: 100,
                scale: 0.8
            },
            out: {
                duration: 800,
                scale: 1
            }
        },
        ZOOM: {
            in: {
                duration: 200,
                scale: 2
            },
            out: {
                duration: 700,
                scale: 1
            }
        }
    };

    TIMER = {};

    function updateOffset() {
        CONFIG.OFFSET = {
            header: $('header').outerHeight()
        };
    }
    updateOffset();

    function getCurrentScrollTop(isDialog) {
        return isDialog ? $scrollParent.scrollTop() : Math.max(CONFIG.ELEMENT.$html.scrollTop(), CONFIG.ELEMENT.$body.scrollTop());
    }

    function getScrollParent($refElement) {
        let $scrollParent;

        $scrollParent = $refElement ? $refElement.closest('.dialog') : $();
        
        if ($scrollParent.length === 0) {
            $scrollParent = CONFIG.ELEMENT.$htmlBody;
        }

        if ($scrollParent.attr('data-fixed-height') === 'yes') {
            $scrollParent = $scrollParent.find('.dialog-content');
        }

        return $scrollParent;
    }

    function animateScale($element, styles, config) {
        return new Promise(function(resolve, reject) {
            let promises;

            if (!$element || ($element.length === 0)) {
                reject('MISSING_ELEMENT');
                return;
            }

            styles = styles || {};

            promises = [];

            $element.each(function() {
                let element;

                element = this;

                promises.push(new Promise(resolveElement => {
                    element.style.transition = `transform ${config.in.duration}ms`;
                    element.style.transform = `scale(${config.in.scale})`;
                    Object.keys(styles).forEach(attr => {
                        element.style[attr] = styles[attr];
                    });
                    setTimeout(() => {
                        element.style.transition = `transform ${config.out.duration}ms`;
                        element.style.transform = `scale(${config.out.scale})`;
                        setTimeout(() => {
                            element.style.transition = '';
                            element.style.transform = '';
                            Object.keys(styles).forEach(attr => {
                                element.style[attr] = '';
                            });
                            resolveElement();
                        }, config.out.duration);
                    }, config.in.duration);
                }));
            });

            Promise.all(promises).then(resolve);
        });
    }

    _this = {
        getScrollTop: function() {
            return getCurrentScrollTop(false);
        },
        scrollTo: function(targetScrollTop, quick, $refElement) {
            return new Promise(function(resolve) {
                var currentScrollTop, animationDuration, isDialog;

                $scrollParent = getScrollParent($refElement);

                isDialog = $scrollParent.hasClass('dialog') || $scrollParent.hasClass('dialog-content');

                currentScrollTop = getCurrentScrollTop(isDialog);

                animationDuration = quick ? 0 : Math.min(1000, Math.round(200 * Math.abs(currentScrollTop - targetScrollTop) / Math.max((isDialog ? $scrollParent.height() : window.innerHeight), 768)));

                $scrollParent.animate({
                    scrollTop: targetScrollTop
                }, animationDuration, function() {
                    resolve();
                });                
            });
        },
        scrollToTop: function(quick, $refElement) {
            return new Promise(function(resolve) {
                $scrollParent = getScrollParent($refElement);

                $scrollParent.animate({
                    scrollTop: 0
                }, quick ? 0 : 500, function() {
                    resolve();
                });
            });
        },
        scrollIntoView: function($element, toTop, quick) {
            return new Promise(function(resolve, reject) {
                let targetScrollTop, $scrollParent, isDialog;

                if (!$element || ($element.length === 0)) {
                    reject('MISSING_ELEMENT');
                    return;
                }
                $element = $element.first();

                updateOffset();

                $scrollParent = getScrollParent($element);

                isDialog = $scrollParent.hasClass('dialog') || $scrollParent.hasClass('dialog-content');

                if (isDialog) {
                    targetScrollTop = $element.offset().top - $scrollParent.offset().top + $scrollParent.scrollTop() - (toTop ? ($scrollParent.find('.dialog-title').outerHeight(true) || 0) : ((($scrollParent.height() - ($scrollParent.find('.dialog-title').height() || 0)) / 2) - ($element.outerHeight(true) / 2)));
                } else {
                    targetScrollTop = $element.offset().top - CONFIG.OFFSET.header - (toTop ? 0 : (((window.innerHeight - CONFIG.OFFSET.header) / 2) - ($element.outerHeight(true) / 2)));
                }

                _this.scrollTo(targetScrollTop, quick, $scrollParent).then(() => {
                    resolve($element);
                });
            });
        },

        pulse: function($element, styles) {
            return animateScale($element, styles, CONFIG.PULSE);
        },

        zoom: function($element, styles) {
            return animateScale($element, styles, CONFIG.ZOOM);
        },

        highlight: function($element) {
            return new Promise(function(resolve) {
                var timerId;

                if (!$element || ($element.length === 0)) {
                    resolve();
                    return;
                }

                clearTimeout(TIMER[$element.attr('data-highlight-timer')]);
                timerId = DataHandler.id();

                $element.attr('data-highlight-timer', timerId);

                $element.removeClass('hasHighlight');
                TIMER[timerId] = setTimeout(() => {
                    $element.addClass('hasHighlight');
                    TIMER[timerId] = setTimeout(() => {
                        $element.removeClass('hasHighlight');
                        $element.removeAttr('data-highlight-timer');
                        delete TIMER[timerId];
                        resolve();
                    }, 3000);
                }, 100);
            });
        },

        removeFocus: function() {
            let trap;

            trap = document.createElement('button');
            trap.type = 'button';
            trap.tabIndex = -1;
            trap.style.position = 'fixed';
            trap.style.opacity = '0';
            trap.style.pointerEvents = 'none';

            document.body.appendChild(trap);
            trap.focus();
            trap.remove();
        }
    };

    return _this;
})();